// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__xfgpI","header":"ReportDetails_header__2R3dH","title":"ReportDetails_title__1BLMW","left":"ReportDetails_left__1xTwc"};